import React, {useContext, useState} from 'react';
import {Modal, ScrollView, Text, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import Select from '../../../../components/Select';
import {colors} from '../../../../assets/styles/colors';
import icon from '../../../../assets/img/icons/pencil-line 1.svg';
import fs_icon from '../../../../assets/img/icons/pencil-line fs.svg';
import ServiceClient from "../../../../utils/ServiceClient";
import {CancelModalProps} from "../../../../types";
import {StoreContext} from "../../../../components/StoreContextProvider";
import YourFriendChallengeCodeForm from "./YourFriendChallengeCodeForm";
import FriendsChallengeConfirmation from './FriendsChallengeConfirmation';
import {isFullSwing} from "../../../../constants";
import P from "../../../../lib/P";

const numberOfShots = [
  {value: '2', customLabel: '', label: '2'}, {value: '3', customLabel: '', label: '3'},
  {value: '4', customLabel: '', label: '4'}, {value: '5', customLabel: '', label: '5'},
  {value: '6', customLabel: '', label: '6'}, {value: '7', customLabel: '', label: '7'},
  {value: '8', customLabel: '', label: '8'}, {value: '9', customLabel: '', label: '9'},
  {value: '10', customLabel: '', label: '10'}
];

const maxParticipants = [
  {value: '2', customLabel: '', label: '2'}, {value: '3', customLabel: '', label: '3'},
  {value: '4', customLabel: '', label: '4'}, {value: '5', customLabel: '', label: '5'},
  {value: '6', customLabel: '', label: '6'}, {value: '7', customLabel: '', label: '7'},
  {value: '8', customLabel: '', label: '8'}, {value: '9', customLabel: '', label: '9'},
  {value: '10', customLabel: '', label: '10'}
];

const entryFree = [
  {value: '3', customLabel: '', label: '$3'}, {value: '5', customLabel: '', label: '$5'},
  {value: '10', customLabel: '', label: '$10'}, {value: '15', customLabel: '', label: '$15'},
  {value: '20', customLabel: '', label: '$20'}
];

type Props = { isOpen: boolean, onClose: () => void, onReload: () => void };

const FriendChallengeDetailsFrom = (props: Props) => {
  const {isOpen} = props;
  const [selectedNumOfShort, setSelectedNumOfShort] = useState('10');
  const [selectedMaxParticipants, setSelectedMaxParticipants] = useState('10');
  const [selectedEntryFree, setSelectedEntryFree] = useState('20');
  const Context = useContext(StoreContext);
  const {cancelModalConfig} = Context;
  const [code, setCode] = useState('');
  const [isOpenFriendsChallengeConfirmation, setIsOpenFriendsChallengeConfirmation] = useState(false);

  const onConfirmAndStart = () => {
    Context.setLoadingOverlay(true);
    props.onClose();
    setIsOpenFriendsChallengeConfirmation(false);

    ServiceClient.createPrivateTournament(+selectedNumOfShort, +selectedMaxParticipants, +selectedEntryFree).then(newTournamentCode => {
      Context.setLoadingOverlay(false);
      setCode(newTournamentCode);

    }).catch(err => {
      console.log('createPrivateTournament err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  return (
    <>
      <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
             onRequestClose={props.onClose}>
        <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
          <ScrollView contentContainerStyle={MainStyle.flex1}>
            <View style={[MainStyle.min_h_full, MainStyle.a_i_c, MainStyle.j_c_c]}>
              <Div w={390} h={502} rounded={20} borderWidth={1} borderColor={colors.settings_border}
                   bg={isFullSwing ? '#131314' : colors.settings_bg} py={isFullSwing ? 0 : 43} alignItems="center"
                   overflow="hidden">
                <P fw="500" fs={26} lh={isFullSwing ? 48 : 26} mb={isFullSwing ? 40 : 21}
                   bg={isFullSwing ? '#252526' : undefined} w="100%" ta="center">
                  Friend Challenge Details
                </P>

                <Div pl={40} pr={52} mb={8} row alignItems="center" justifyContent="space-between">
                  <Text style={styles.label}>Number of Shots:</Text>

                  <Select
                    value={selectedNumOfShort} onChangeText={(val) => setSelectedNumOfShort(val)}
                    customItems={numberOfShots} pl={35} pr={23} w={130} borderRadius={isFullSwing ? 4 : 20} h={60}
                    textAlign="left"
                    icon={isFullSwing ? fs_icon : icon} fontSize={22} borderColor={colors.settings_border}
                    bg={isFullSwing ? '#252526' : colors.mainBackground}
                    color={isFullSwing ? '#0AF' : colors.newGreenText} iconSize={24} popupTitle="Number of Shots"
                  />
                </Div>

                <Div pl={40} pr={52} mb={8} row alignItems="center" justifyContent="space-between">
                  <Text style={styles.label}>Max Participants:</Text>

                  <Select
                    value={selectedMaxParticipants} onChangeText={val => setSelectedMaxParticipants(val)}
                    customItems={maxParticipants} pl={35} pr={23} w={130} borderRadius={isFullSwing ? 4 : 20} h={60}
                    textAlign="left"
                    icon={isFullSwing ? fs_icon : icon} fontSize={22} borderColor={colors.settings_border}
                    bg={isFullSwing ? '#252526' : colors.mainBackground}
                    color={isFullSwing ? '#0AF' : colors.newGreenText} iconSize={24} popupTitle="Max Participants"
                  />
                </Div>

                <Div pl={40} pr={52} mb={31} row alignItems="center" justifyContent="space-between">
                  <Text style={styles.label}>Entry Fee:</Text>

                  <Select
                    value={selectedEntryFree} onChangeText={val => setSelectedEntryFree(val)}
                    customItems={entryFree} pl={27} pr={23} w={130} borderRadius={isFullSwing ? 4 : 20} h={60}
                    textAlign="left"
                    icon={isFullSwing ? fs_icon : icon} fontSize={22} borderColor={colors.settings_border}
                    bg={isFullSwing ? '#252526' : colors.mainBackground}
                    color={isFullSwing ? '#0AF' : colors.newGreenText} iconSize={24} popupTitle="Entry Fee"
                  />
                </Div>

                <Button
                  text="Start New Friend Challenge" onPress={() => setIsOpenFriendsChallengeConfirmation(true)}
                  w={309} fontWeight="600" mb={13} color={isFullSwing ? 'white' : undefined}
                  radius={isFullSwing ? 4 : undefined} bg={isFullSwing ? '#3369FF' : undefined}
                />

                <Button
                  text="Cancel" onPress={props.onClose} w={309} fontWeight="600" borderWidth={1}
                  borderColor={isFullSwing ? '#4C4C4C' : 'white'} bg={isFullSwing ? '#252526' : colors.mainBackground}
                  color="white" radius={isFullSwing ? 4 : undefined}
                />
              </Div>
            </View>
          </ScrollView>
        </View>
      </Modal>

      <YourFriendChallengeCodeForm
        code={code}
        onClose={() => {
          setCode('');
          props.onReload();
        }}
      />

      <FriendsChallengeConfirmation
        maxParticipants={+selectedMaxParticipants}
        totalShots={+selectedNumOfShort}
        entryFee={+selectedEntryFree}
        isOpen={isOpenFriendsChallengeConfirmation}
        onConfirm={onConfirmAndStart}
        onClose={() => setIsOpenFriendsChallengeConfirmation(false)}
      />
    </>
  );
};

const styles = {
  label: [MainStyle.w_160, MainStyle.c_white, MainStyle.t_a_c, MainStyle.Barlow500, MainStyle.f_s_16, MainStyle.t_t_u]
};

export default React.memo(FriendChallengeDetailsFrom);
